import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// EC-874 : Adding border for the header cell in saved order list table
savedOrderListTableStyles.orderDateHeader = {
    css: css`
        border-right: 2px solid ${getColor("common.border")};
    `,
};

savedOrderListTableStyles.shipToLabelHeader = {
    css: css`
        border-right: 2px solid ${getColor("common.border")};
    `,
};
// EC-874 : Adding border for the header cell in saved order list table
